module.exports = __webpack_public_path__ + "img/prv.bb054646.png";